























import Vue from 'vue'
import MovieButton from '@/views/templates/africadogs/atoms/MovieButton.vue'
import ScrollFire from '@/views/mixin/ScrollFire'
import FooterBuyArea from '@/views/molecules/FooterBuyArea.vue'
import PopupCircleEpisode from '@/views/templates/africadogs/PopupCircleEpisode.vue'

Vue.mixin(ScrollFire)

export default
  components: {
    MovieButton
    PopupCircleEpisode
    FooterBuyArea
  }
  data: () ->
    subtitle: [
      '炎のカケラをGET！'
    ]
    message: [
      '今日は僕たちAFURIKA DOGSの取り組みや'
      '文化を大切にしている職人さんたちの話を'
      '聞いてくれてありがとう！'
      'またいつでもおいで！'
    ]
    showPopup: 0
    fire_scroll: true
  created: () ->
    @$options.scroll_target = '.episode7'
  methods:
    scrollFire: () ->
      if @showPopup == 0
        @showPopup = 1
    closePopup: () ->
      @showPopup = 2
    addPoint: (point) ->
      @$emit('addPoint', point)
